function StepCard({
  title,
  question,
  value,
  onChange,
  onNext,
  onBack,
  isFirst,
  isLast,
  maxLength,
  disableNext = false, // NEW (optional)
}) {
  const isValueEmpty =
    typeof value === "string" ? value.trim().length === 0 : !value;

  return (
    <div className="step-card">
      <h2>{title}</h2>
      <p>{question}</p>

      {/* Default text input */}
      <input
        type="text"
        value={value}
        maxLength={maxLength}
        onChange={(e) => onChange(e.target.value)}
        className="step-input"
      />

      {maxLength && typeof value === "string" && (
        <p style={{ fontSize: "12px", color: "#64748b" }}>
          {value.length}/{maxLength} characters
        </p>
      )}

      <div className="step-actions">
        {!isFirst && (
          <button className="secondary-button" onClick={onBack}>
            Back
          </button>
        )}

        <button
          className="primary-button"
          onClick={onNext}
          disabled={disableNext || isValueEmpty}
        >
          {isLast ? "Finish" : "Next"}
        </button>
      </div>
    </div>
  );
}

export default StepCard;
